import * as actions from "../actions/AdminEmailTemplateActions";
import { AdminEmailTemplateState, initialState } from "../store/AdminEmailTemplateState";
import buildReducer from "../utils/ReducerBuilder";

export const AdminEmailTemplateReducer = buildReducer<AdminEmailTemplateState>(initialState)
    .handle(actions.onTemplatesUpdated, (state, action) => ({
        ...state,
        templates: action.payload || state.templates,
    }))
    .handle(actions.onTypesUpdated, (state, action) => ({
        ...state,
        types: action.payload || state.types,
    }))
    .handle(actions.toggleLoadingTemplate, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingTemplate = { ...state.loadingTemplate };
        loadingTemplate[action.payload.id] = action.payload.loading;

        return {
            ...state,
            loadingTemplate,
        };
    })
    .handle(actions.toggleLoadingTemplates, (state, action) => ({
            ...state,
            loadingTemplates: action.payload || false,
    }))
    .handle(actions.toggleLoadingTypes, (state, action) => ({
            ...state,
            loadingTypes: action.payload || false,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AdminEmailTemplateReducer.ts